import { Helmet } from "react-helmet-async";

const SITE = "https://veristamp.app";
const OG_IMAGE = `${SITE}/assets/og_social_card.png`;

export const Seo = ({ title, description, path, jsonLd = [] }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`${SITE}${path}`} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={`${SITE}${path}`} />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Veristamp" />
    <meta property="og:image" content={OG_IMAGE} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={OG_IMAGE} />
    {jsonLd.map((obj, i) => (
      <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
    ))}
  </Helmet>
);
